<template>
  <div class="sidebar-box">
    <a-icon type="right-circle" theme="filled" class="icon"  v-show="isOpenShow"
      @click="showDrawer" />
    <span class="device-total" v-show="isOpenShow">{{$t('home.totalNumber') + '（' + total + '）'}}</span>
    <a-drawer :title="$t('home.totalNumber') + '（' + total + '）'" placement="left" :closable="false" :visible="visible" :mask="false"
      :maskClosable="false" width="400px" wrapClassName="sidebar-content">
      
      <a-row>
        <a-col span="21" offset="1">
          <z-org-chooser ref="orgChooser" :option="orgOption" @orgSelect="onOrgSelect"></z-org-chooser>
        </a-col>
      </a-row>

      <a-row style="margin-top: 15px;">
        <a-col span="21" offset="1">
          <z-scene-chooser ref="sceneChooser" :orgId="orgSelectScene" :option="sceneData" @sceneSelect="onSceneSelect"></z-scene-chooser>
        </a-col>
      </a-row>

      

      <div class="search-box" style="margin-top:15px">
        <a-input-search :placeholder="$t('home.searchTip')" style="width:87%" @search="onSearch" @blur="onSearch"
          v-model.trim="searchData"  size="small" />
      </div>

      <div class="search-box" style="margin-top:15px;  width: 350px">
        <!-- <a-radio-group  @change="onShowChange" v-model="showType" :defaultValue="showType" buttonStyle="solid">
          <a-radio-button value="all">全部</a-radio-button>
          <a-radio-button value="online">在线</a-radio-button>
          <a-radio-button value="onbind">绑表</a-radio-button>
        </a-radio-group> -->
        <ZxMenu @onShowChange="onShowChange" @onShownModeChange="onShownModeChange" />
      </div>
      

      <div class="tab-box" style="width: 380px">
         
            <z-collapse-org-and-device
              v-if="shownMode === 'tree'"
              ref="collapseOrg"
              :collapseData="collapseData"
              @changeLength="changeLength"
              @changeIsExpand="changeIsExpand">
            </z-collapse-org-and-device>
            <EntitysList v-if="shownMode === 'list'" :entitysData="filteredEntitysData" />
          
      </div>

      <a-icon type="left-circle"  theme="filled" v-show="isCloseShow" @click="onClose" class="icon" />
    </a-drawer>
  </div>
</template>

<script>
  import ZOrgChooser from '@/components/common/OrgChooser.vue'
  import ZSceneChooser from '@/components/common/SceneChooser.vue'
  //import OrgItem from './OrgItem'
  import {mapActions} from 'vuex'
  import ZCollapseOrgAndDevice from './CollapseOrgAndDevice.vue'
  import EntitysList from './EntitysList'
  import ZxMenu  from '../../components/common/ZxMenu'
  import bus from '../../bus/bus'
  import config from '@/config'
  export default {
    name: "ZSodeBar",
    props: ['collapseData', 'filteredEntitysData', 'dataOnline', 'dataOffline', 'dataAlarm', 'groups', 'total'],
    data() {
      return {
        shownMode: 'tree',
        showType: {
          bindStatu: 'all',
          customType: 'all'
        },
        // 搜索时选中的orglink
        onSelectedOrg: '',
        // 搜索的内容
        searchData: '',
        visible: true,
        isOpenShow: true,
        isCloseShow: true,
        selectIsShow: false,
        selectedRowKey: null,
        columns: [{
            "title": "icon",
            "key": "icon",
            "dataIndex": "icon",
            "scopedSlots": {
              "customRender": "icon"
            }
          },
          {
            "title": "entity",
            "key": "entity",
            "dataIndex": "entity",
            "scopedSlots": {
              "customRender": "entity"
            }
          },
          // {
          //   "title": "org",
          //   "key": "org",
          //   "dataIndex": "org",
          // },
          {
            "title": "group",
            "key": "group",
            "dataIndex": "group",
          },
          {
            "title": "sn",
            "key": "sn",
            "dataIndex": "sn",
            "scopedSlots": {
              "customRender": "bindStatus"
            }
          },
          {
            "title": "alarmNum",
            "key": "alarmNum",
            "dataIndex": "alarmNum",
            "scopedSlots": {
              "customRender": "alarmNum"
            }
          }
          // {
          //   "title": "id",
          //   "key": "id",
          //   "dataIndex": "id",
          //   "scopedSlots": {
          //     "customRender": "search"
          //   }
          // }
        ],
        pagination: {
          showSizeChanger: false,
          pageSize: 10,
          current: 1,
          showQuickJumper: true
        },
        orgOption: {
          value: ""
        },
        sceneData: {
          value: ""
        },
        deviceType: {
          allowClear: true,
          value: '',
          modelName: null
        },
        expandedKeys: ['0-0-0', '0-0-1'],
        autoExpandParent: true,
        checkedKeys: [],
        selectedKeys: [],
        allTreeData: [],
        treeData: [],
        orgSelectScene: undefined
      }
    },
    components: {
        ZOrgChooser,
        ZSceneChooser,
        ZCollapseOrgAndDevice,
        ZxMenu,
        EntitysList
    },
    methods: {
      ...mapActions(['changedHomeOrgId']),
      // 设置表格的行属性，此处用于捕捉点击某一行
      changeIsExpand(orgId,isExpand){
        this.$emit("changeIsExpand",orgId,isExpand)
      },
      changeLength(orgId,length){
        this.$emit("changeLength",orgId,length)
      },
      clickRow (recode, index) {
        return {
          on: {
            // 点击某一行时触发
            click: () => {
              // console.log(recode)
              // 显示地图上的infoBox
              this.showInfo(recode)
            }
          }
        }
      },
      resetSelectedKey() {
        this.selectedRowKey = null
      },
      getClass(record) {
        if (record.id == this.selectedRowKey) {
          return 'ant-table-row-selected'
        }
        return 'table-row'
      },
      setSelectedRowKey(selectedRowKey) {
        this.selectedRowKey = selectedRowKey
      },
      showInfo(record) {
        this.selectedRowKey = record.id
        this.$emit("showInfo", record)
      },
      resetPage() {
        this.pagination.current = 1
      },
      pageChange(pagination) {
        this.pagination.current = pagination.current
      },
      onGroupChange(group) {
        this.$emit('groupChange', group)
        this.resetPage()
      },
      // 选择机构
      onOrgSelect(org) {
        console.log(org)
        this.onSelectedOrg = org.link
        this.orgSelectScene = org.scenes
        let searchParam = {
          org: this.onSelectedOrg,
          search: this.searchData,
          type: this.showType
        }
        // console.log(org)
        // this.$store.dispatch('changedOrgId', org.id)
        this.changedHomeOrgId(org.id)
        this.doSearch(searchParam)
        // this.getScenesTree(org.scenes)
        // this.$emit('orgChange', org)
        // this.resetPage()
      },
      onSceneSelect(scene) {
        this.getScenesTree(this.orgSelectScene)
        setTimeout(() => {
          this.$emit('showTileLayer', scene)
        }, 500)
      },
      // 获取场景树 
      getScenesTree(id) {
        this.$http.get(config.api.get_scenes_fence + id).then(resp => {
          if(resp.code == 0) {
            this.allTreeData = resp.result
            // console.log("场景树:",this.allTreeData);
            this.$emit('treeData', this.allTreeData)
          }
        })
      },
      // filterTreeData(arr) {
      //   arr.forEach((item) => {
      //     if(item.type < 2) {
      //       item.children = item.children;
      //     }
      //     if(item.type == '')
      //     item['scopedSlots'] = { title: 'custom' };
      //     item.title = item.title;
      //     // item.Id = item?.slots?.Id;
      //     // item.Name = item?.slots?.Name;
      //     // item.selectable = true;
      //     // item.subTitle = item.title + '(' + item.key + ')';
      //     this.$forceUpdate();
      //     if (item.children) {
      //       this.filterTreeData(item.children);
      //     }
      //   });
      //   return arr
      // },
      // 搜索框搜索
      onSearch() {
        let searchParam = {
          org: this.onSelectedOrg,
          search: this.searchData,
          type: this.showType
        }
        // console.log('i do ?')
        this.doSearch(searchParam)
        // console.log(search)
        // console.log(this.searchData)
        // this.$emit('searchChange', this.searchData)
        // this.resetPage()
      },
      // 选择在线绑表的选择
      // onShowChange () {
      //   // console.log(this.showType)
      //   let searchParam = {
      //     org: this.onSelectedOrg,
      //     search: this.searchData,
      //     type: this.showType
      //   }
      //   this.doSearch(searchParam)
      // },
      // 选择在线绑表的选择
      onShowChange (emitParam) {
        // console.log(this.showType)
        this.showType = emitParam
        let searchParam = {
          org: this.onSelectedOrg,
          search: this.searchData,
          type: this.showType
        }
        this.doSearch(searchParam)
      },
      onShownModeChange (mode) {
        // console.log(mode)
        this.shownMode = mode.shownMode
      },
      doSearch (param) {
        // console.log('i do it')
        this.$emit('doSearch', param)
        // this.resetPage()
      },
      showDrawer() {
        this.visible = true
        this.isOpenShow = false
        this.isCloseShow = true
        bus.$emit('onDrawerChange', this.visible)
      },
      onClose() {
        this.visible = false
        this.isOpenShow = true
        this.isCloseShow = false
        bus.$emit('onDrawerChange', this.visible)
      },
      // onSelect(selectedKeys, info) {
      //   this.selectedKeys = selectedKeys;
      //   this.$emit('showTileLayer', info.node.dataRef)
      // },
    },
    mounted () {
      // console.log(this.$i18n)
    }
  }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.icon {
  font-size: 25px;
  color: @link-color;
}
.table-row {
  cursor: pointer !important;
}
</style>
